export const userTypes = [
  {
    title: "Administrador",
    id: "ADMIN",
  },
  {
    title: "Gerente",
    id: "MANAGER",
  },
  {
    title: "Vendedor",
    id: "SELLER",
  },
  {
    title: "Funcionário",
    id: "USER",
  },
  {
    title: "Cliente",
    id: "CLIENT",
  },
];
